import { render, staticRenderFns } from "./loveRecommend.vue?vue&type=template&id=432e3faf&"
import script from "./loveRecommend.vue?vue&type=script&lang=js&"
export * from "./loveRecommend.vue?vue&type=script&lang=js&"
import style0 from "./loveRecommend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports